import { render, staticRenderFns } from "./AccountTransferList.vue?vue&type=template&id=bd6aa3a2&scoped=true"
import script from "./AccountTransferList.vue?vue&type=script&lang=js"
export * from "./AccountTransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6aa3a2",
  null
  
)

export default component.exports